import { QueryHookOptions, gql } from '@apollo/client'
import { usePersistedCacheQuery } from 'app/hooks'

const query = gql`
  query searchBrands($searchTerm: String, $limit: Int, $page: Int) {
    searchBrands(searchTerm: $searchTerm, limit: $limit, page: $page) {
      totalDocs
      page
      docs {
        id
        name
        description
        logo {
          id
          url
          alt
        }
        featuredImage {
          id
          url
          alt
        }
        slug
      }
    }
  }
`

export interface SearchBrandsQueryInput {
  searchTerm: string
  limit: number
  page: number
}

const defaultVariables: SearchBrandsQueryInput = {
  searchTerm: '',
  limit: 8,
  page: 1,
}

export interface SearchBrandsQueryOutput {
  searchBrands: {
    totalDocs: number
    page: number
    docs: {
      id: string
      name: string
      description: string
      logo?: {
        url: string
      }
      featuredImage?: {
        url: string
      }
      slug: string
    }[]
  }
}

export const useSearchBrandsQuery = (options: QueryHookOptions<SearchBrandsQueryOutput, SearchBrandsQueryInput>) =>
  usePersistedCacheQuery<SearchBrandsQueryOutput, SearchBrandsQueryInput>(query, {
    ...options,
  })


export const searchBrandsQuery = { query, defaultVariables }
